export const DEFAULT_PROPERTY_METRICS = {
  propertyType: 'urban',
  adr: '',
  averageLengthOfStay: '',
  customConversionPercent: '',
}

const PROPERTY_TYPE_OPTIONS = [
  { value: 'urban', label: 'Urban' },
  { value: 'resort', label: 'Resort' },
]

const VALID_PROPERTY_TYPES = new Set(PROPERTY_TYPE_OPTIONS.map((o) => o.value))

function normalizePropertyType(value) {
  return VALID_PROPERTY_TYPES.has(value) ? value : DEFAULT_PROPERTY_METRICS.propertyType
}

function unwrapMarketingSettingsResponse(response) {
  if (response == null) return null
  if (typeof response !== "object") return null
  const inner = response.data
  if (inner && typeof inner === "object" && !Array.isArray(inner)) return inner
  return response
}

/** API → form fields for Property metrics modal. */
export function marketingSettingsToPropertyMetrics(api) {
  if (!api || typeof api !== "object") return { ...DEFAULT_PROPERTY_METRICS }

  let customConversionPercent = ""
  if (api.conversion != null && api.conversion !== "" && !Number.isNaN(Number(api.conversion))) {
    customConversionPercent = String(Number(api.conversion) * 100)
  }

  return {
    propertyType: normalizePropertyType(api.propertyType),
    adr:
      api.averageDefaultRate != null && api.averageDefaultRate !== ""
        ? String(api.averageDefaultRate)
        : "",
    averageLengthOfStay:
      api.averageLengthOfStay != null && api.averageLengthOfStay !== ""
        ? String(api.averageLengthOfStay)
        : "",
    customConversionPercent,
  }
}

function parseMetricNumber(value) {
  const n = parseFloat(String(value ?? "").replace(/[^0-9.-]/g, ""))
  return Number.isFinite(n) ? n : null
}

/** Form fields → POST/PATCH body for client-marketing-settings. */
export function propertyMetricsToMarketingSettings(form) {
  const body = {
    propertyType: normalizePropertyType(form?.propertyType),
  }

  const adr = parseMetricNumber(form?.adr)
  const los = parseMetricNumber(form?.averageLengthOfStay)
  const convPct = parseMetricNumber(form?.customConversionPercent)

  if (adr != null) body.averageDefaultRate = adr
  if (los != null) body.averageLengthOfStay = los
  if (convPct != null) body.conversion = convPct / 100

  return body
}

export { unwrapMarketingSettingsResponse }

export const PROPERTY_METRIC_FIELDS = [
  { key: 'propertyType', label: 'Property Type', type: 'select', options: PROPERTY_TYPE_OPTIONS },
  { key: 'adr', label: 'ADR', prefix: '$', placeholder: '245', inputMode: 'decimal' },
  {
    key: 'averageLengthOfStay',
    label: 'Average Length of Stay',
    suffix: ' nights',
    placeholder: '2.4',
    inputMode: 'decimal',
  },
  {
    key: 'customConversionPercent',
    label: 'Custom Conversion %',
    suffix: '%',
    placeholder: '12',
    inputMode: 'decimal',
  },
]

export function loadPropertyMetrics(clientId) {
  if (!clientId) return { ...DEFAULT_PROPERTY_METRICS }
  return { ...DEFAULT_PROPERTY_METRICS }
}

export function savePropertyMetrics(_clientId, _metrics) {
  /* persisted via client-marketing-settings API */
}
